import React from 'react';
import { useAppSelector } from '@redux/store';

import { SocialTaskItem } from '../SocialTaskItem/SocialTaskItem';

const SocialNetworkBody: React.FC = () => {
  const socialTasks = useAppSelector((state) => state.tasks.social);

  return (
    <div className="tabs__list pt-2">
      {socialTasks?.map((partner, index) => (
        <div key={`partner-${index}`} className="flex flex-col gap-1">
          {partner.partnerTask?.map((task) => (
            <SocialTaskItem key={task.id} {...task} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default SocialNetworkBody;
